var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"el-input"},[_c('el-input',{staticStyle:{"text-align":"right"},attrs:{"type":"text","value":_vm.val,"maxlength":"24"},on:{"input":function($event){return _vm.change($event)}}},[_c('template',{slot:"append"},[_vm._v("%")])],2)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b6789a38","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/card/components/MarginInput.vue
// module id = null
// module chunks = 